import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { getCheckoutHref, handleCheckoutClick } from '../utils/checkout';
import { primaryButtonClass, type ButtonSize } from '../utils/buttonStyles';
interface CheckoutButtonProps {
  label: string;
  id?: string;
  size?: ButtonSize;
  className?: string;
  tabIndex?: number;
}

/**
 * Every purchase CTA (offer, final, sticky) goes through here so they share
 * one destination, configured in data/checkout.ts. Until a checkout URL is
 * set, the button scrolls to the offer.
 */
export function CheckoutButton({
  label,
  id,
  size = 'md',
  className = '',
  tabIndex
}: CheckoutButtonProps) {
  return <a id={id} href={getCheckoutHref()} onClick={handleCheckoutClick} tabIndex={tabIndex} className={`${primaryButtonClass(size)} ${className}`} data-id="element-41" data-mp="18nuidldctn65">
      <span data-id="element-42" data-mp="330amafiogp7u">{label}</span>
      <ArrowRightIcon className="h-[18px] w-[18px] shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" strokeWidth={2.5} aria-hidden data-id="element-43" data-mp="32zhklsykspwk" />
    </a>;
}